define('app/models/User',['require','common/cookie','glu/log','glu/http','glu/model','app/models/UserPreferenceCollection','app/models/UserPreference','config','app/store'],function(require) {
	'use strict';

	var cookie = require('common/cookie'),
		log = require('glu/log'),
		http = require('glu/http'),
		Model = require('glu/model'),
		UserPreferenceCollection = require('app/models/UserPreferenceCollection'),
		UserPreference = require('app/models/UserPreference'),
		config = require('config'),
		sessionStore = require('app/store');

	return Model.extend({

		url: function() {
			return config.apiRoot + 'service/userprofile';
		},

		parse: function(response) {
			this.set('preferenceCollection', new UserPreferenceCollection(response.preferences));
			var role = response.role;
			if (role === 'BASIC') {
				this.set('isBasicUser', true);
			} else if (role === 'ADVANCED') {
				this.set('isAdvanceUser', true);
			} else if (role === 'INTERNAL') {
				this.set('isInternalUser', true);
			}
			this.set('tenantId', response.tenantId);
		},

		getPreferenceCollection: function() {
			return this.get('preferenceCollection');
		},

		isInternalUser: function() {
			return this.get('isInternalUser');
		},

		isAdvanceUser: function() {
			return this.get('isAdvanceUser');
		},

		isBasicUser: function() {
			return this.get('isBasicUser');
		},

		isReadOnly: function() {
			return (this.get('isBasicUser') || this.get('isInternalUser'));
		},

		getUsername: function() {
			return sessionStore.getApiUsername();
		},

		getTenantId: function() {
			return this.get('tenantId');
		},

		getLastSelectedDashboardId: function() {
			return cookie.get('last-selected-dashboard-id_' + this.getUsername());
		},

		setLastSelectedDashboardId: function(id) {
			cookie.set('last-selected-dashboard-id_' + this.getUsername(), id, {
				secure: true
			});
		},

		getLastSelectedUserInternal: function() {
			return cookie.get('last-selected-user-id_' + this.getUsername());
		},

		setLastSelectedUserInternal: function(username) {
			cookie.set('last-selected-user-id_' + this.getUsername(), username, {
				secure: true
			});
		},

		logout: function() {
			sessionStore.setApiUsername(null);
			sessionStore.setApiToken(null);
			http.post(config.apiRoot + 'auth/logout');
			http.setRequestHeaders({
				'API-TOKEN': undefined
			});
		},

		//saves an object by it's key in a storage which survives restarts (local storage)
		// if you try saving 'null' value, this will remove an object from the storage
		saveObject: function(key, obj) {
			try {
				if (obj === null) {
					window.localStorage.removeItem(key);
				} else {
					var s = JSON.stringify(obj);
					window.localStorage.setItem(key, s);
				}
			} catch (e) {
				log.warn('Could not save an object with \'' + key + '\' key due to: ' + e.toString());
			}
		},

		//loads on object by its key.
		// if no such key found, or error happens, the provided 'defValue' is returned (or 'undefined')
		loadObject: function(key, defValue) {
			try {
				var s = window.localStorage.getItem(key);
				if (s === null) {
					return defValue;
				}
				return JSON.parse(s);
			} catch (e) {
				log.warn('Could not load an object for \'' + key + '\' key due to: ' + e.toString());
				return defValue;
			}
		},

		getUserPreference: function(name) {
			var result = this.getPreferenceCollection().get(name);
			if (result) {
				return result.getValue();
			} else {
				return null;
			}
		},

		saveUserPreference: function(name, value) {
			var preference = this.getPreferenceCollection().get(name);
			if (preference) {
				preference.setValue(value);
			} else {
				preference = new UserPreference({
					name: name,
					value: value
				});
				this.getPreferenceCollection().add(preference);
			}
			preference.save();
		}
	});
});

